import { useConfigSlice } from '../store/slices/config/selectors';

import { isLobbyButtonHidden } from './helpers/isLobbyButtonHidden';

export const useIsLobbyButtonHiddenConnected = (): boolean => {
  const isLobbyButtonHiddenTableConfig = useConfigSlice.tableConfig()?.hideLobby;
  const isLobbyButtonHiddenCasinoConfig = useConfigSlice.casinoConfig()?.hideLobbyButtons;

  return isLobbyButtonHidden(isLobbyButtonHiddenTableConfig, isLobbyButtonHiddenCasinoConfig);
};
